export default "__VITE_ASSET__DCGvU3aK__"